import { csx } from '@vtex/admin-ui'

const styles = {
  tagsList: csx({
    display: 'flex',
    flexDirection: 'row',
    columnGap: '$space-2',
    rowGap: '$space-2',
  }),
  tagsListTruncate: csx({
    display: 'flex !important',
    gap: '0.5rem',
    flexWrap: 'wrap',
  }),
  tag: csx({
    display: 'inline-flex',
    borderRadius: 4,
    color: '$secondary',
    paddingY: '$space-1',
    paddingX: '$space-2',
    marginY: 'auto',
    overflowX: 'clip',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    background: '$secondary',
    maxWidth: '100%',
    ':hover': {
      cursor: 'text',
    },
  }),
  tagItem: csx({
    maxWidth: '100%',
    '& p': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      marginRight: '$space-1',
    },
  }),
}

export default styles
